module.exports = __webpack_public_path__ + "img/coin.aa9989ab.png";